import React, { Component } from 'react';
// import ReactDOM from "react-dom";
import { connect } from 'react-redux';
// import * as Contracts from '../../Store/Contracts';
import * as Transfer from './Saga/Transfer';
import Button from '@material-ui/core/Button';
import PersonIcon from '@material-ui/icons/Person';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
// import '../../Css/Grid.css';

import DateFnsUtils from '@date-io/date-fns';
import ja from "date-fns/locale/ja";
var moment = require("moment-timezone");

const ReactDataGrid = require('react-data-grid');
const { MuiPickersUtilsProvider,KeyboardDatePicker } = require('@material-ui/pickers');
interface Props {
  application_transfer_accounts: any,
  shops:any,
  transfer_modal:boolean,
  change_transfer_modal:any,
  new_rent_transfer_accounts:any,
  registration_rent_transfer_accounts:any,
}



interface State {
  columns: any
  refresh: boolean
  applicationDate:any
  applicationEndDate:any
//   list: any,
//   kytoggle: boolean
  // state types
}


const DateFormatter = (payload: any) => {
  if (payload.value) {
    // return moment(payload.value).date();
    // return moment(payload.value).utcOffset(payload.value).tz("Asia/Tokyo").format('YYYY/MM/DD')
    return moment(payload.value).format("YYYY/MM/DD");
  } else {
    return "";
  }
};

const depositkindFormatter = (payload: any) => {
  if (payload.value === 1) {
    return "普通";
  } else {
    return "";
  }
};

const siteFormatter = (payload: any) => {

  if (payload.value === 1) {
    return <span style={{ color: "blue", fontWeight: "bold" }}>へやのしおり</span>;
  } else if (payload.value === 2) {
    return <span style={{ color: "red", fontWeight: "bold" }}>マイページ</span>;
  } else if (payload.value === 3) {
    return <span style={{ color: "green", fontWeight: "bold" }}>グローバルパーキング</span>;
  } else if (payload.value === 4) {
    return <span style={{ color: "#FFA500", fontWeight: "bold" }}>スマート切替</span>;
  } else {
    return "";
  }
};

const tatemonoFormatter = (payload: any) => {
    return <span>{payload.row.free_tatemono_name}</span>;
};

const roomFormatter = (payload: any) => {
    return <span>{payload.row.free_room_name}</span>;
};

const nameFormatter = (payload: any) => {
    return <span>{payload.row.free_name}</span>;
};

const sectionFormatter = (payload: any) => {
    return <span>{payload.row.free_kouza_reason === 1 ? "口座変更" : payload.row.free_kouza_reason === 2 ? "浄水器引落" : payload.row.free_kouza_reason === 3 ? "新規受託" : ""}</span>;

};


// const SelectFormatter =(payload:any) => {
//   console.log(payload)
//   if(payload.row.receipt_at && payload.row.payment_at){
//     // return moment(payload.value).format("YYYY/MM/DD");
//     return <div>　</div>
//   }else{
//     return <div  style={{background:"#CCC"}}>　</div>;
//   }
//   };

const conditionFormatter = (payload: any) => {
  if (payload.value) {
    return moment(payload.value).format("YYYY/MM/DD");
  } else {
    return "";
  }
};

const ContractFormatter = (payload: any) => {
  console.log(payload)
  if (payload.row.contract_cancel === 1) {
    return "キャンセル " + payload.row.contract_remarks;
  } else if (payload.row.contract_amount && payload.row.works === 1) {
    return payload.row.contract_amount + " " + payload.row.contract_remarks;
  } else if (payload.row.rent_m_etc_id === 3) {
    return "無し " + payload.row.contract_remarks;
  } else if (payload.row.rent_m_etc_id === 4 && payload.row.works === 1) {
    return "WEB " + payload.row.contract_remarks;
  } else if (payload.row.works === 2) {
    return "他社 " + payload.row.contract_remarks;
  } else if (payload.row.works === 3) {
    return "家主 " + payload.row.contract_remarks;
  } else {
    return "";
  }
};


const defaultColumnProperties = {
  sortable: true,
  // width: 120
};




/**
 *会計連動グリッド
 *
 * @class AccountingGridComponent
 * @extends {Component<Props, State>}
 */
class AccountingGridComponent extends Component<Props, State> {
  constructor(props: Readonly<Props>) {
    super(props);


    this.state = {
      refresh: false,
      applicationDate: moment().subtract(30, 'days').format("YYYY/MM/DD"),
      applicationEndDate:moment().format("YYYY/MM/DD"),
      columns: [
        // { key: 'id', name: 'ID', width: 60, resizable: true },
        { key: 'state', name: '', width: 60, resizable: true, formatter: siteFormatter }, 
        { key: 'site', name: 'サイト', width: 60, resizable: true, formatter: siteFormatter },     
        { key: 'created_at', name: '登録日', width: 100, resizable: true, formatter: DateFormatter },
        { key: 'tatemono_name', name: '建物名', width: 150, resizable: true, formatter: tatemonoFormatter },
        { key: 'room_name', name: '部屋名', width: 60, resizable: true, formatter: roomFormatter },
        { key: 'rent_customer_name', name: '顧客名', width: 100, resizable: true, formatter: nameFormatter },
        { key: 'contract_date', name: '契約日', width: 130, resizable: true, formatter: DateFormatter },
        { key: 'section_name', name: '店舗', width: 100, resizable: true, formatter: sectionFormatter },
        { key: 'bank_code', name: '銀行番号', width: 100, branch_id: true },
        { key: 'bank_name', name: '銀行名', width: 100, branch_id: true },
        { key: 'shop_code', name: '支店番号', width: 100, branch_id: true },
        { key: 'shop_name', name: '支店名', width: 80, resizable: true },
        { key: 'deposit_kind', name: '口座種別', width: 60, resizable: true, formatter: depositkindFormatter },
        { key: 'account_number', name: '口座番号', width: 100, resizable: true },
        { key: 'account_name_katakana', name: '口座名義', width: 100, resizable: true },
      ].map(c => ({ ...c, ...defaultColumnProperties })),

    //   list: this.props.application_transfer_accounts,
    //   kytoggle: false,



    };

    // this.sortRows = this.sortRows.bind(this);
    this.SectionFormatter = this.SectionFormatter.bind(this);
    // this.getCellActions = this.getCellActions.bind(this);
    this.getRowCount = this.getRowCount.bind(this);
    // this.onGridRowsUpdated = this.onGridRowsUpdated.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
  }


  // onGridRowsUpdated = ({ fromRow, toRow, updated }: any) => {


  //   let kyousais = this.props.application_transfer_accounts.slice();
  //   // for (let i = fromRow; i <= toRow; i++) {
  //   //   kyousais[i] = { ...kyousais[i], ...updated };
  //   // }


  //   this.props.change_kyousais(kyousais)

  // };

  SectionFormatter = (payload: any) => {

    const result = this.props.shops.filter((x: any) => x.tenpoNo === payload.value);

    return result[0].tenpoName;

  };


  componentWillMount() {

    // this.props.get_banks({output:true,name:"",date1:"",date2:""})


  }
  getSelectedCell(event: any) {
    alert()
  }

  // onRowClick = (rowIdx: any, row: any) => {
  onRowClick = (rowIdx: any) => {
    // console.log(rowIdx)
    // this.props.kyousais[rowIdx.rowIdx].condition = 1
    // this.props.kyousais.concat([])
    // row.condition = 1
    // this.setState({
    //   refresh: true
    // });
    // for (let i = fromRow; i <= toRow; i++) {
    //   kyousais[i] = { ...kyousais[i], ...updated };
    // }
    // kyousais[rowIdx].condition = 1
    // let kyousais = this.props.kyousais
    // this.props.change_kyousais(kyousais)
  }
  // componentDidUpdate() {
  //   if (this.props.grid_update === true) {
  //     this.setState({
  //       refresh: true
  //     });
  //     // this.props.change_grid_update(false)
  //   }
  //   // alert("update")
  // }
  // this.props.get_banks({output:true,name:"",date1:"",date2:""})


  // rowGetter = (i:number) => {
  //     return this.props.rent_contracts_list[i];
  //   };
  handleChange = (e:any) => {
    console.log(e,"変えた")
  }
  onRowsSelected = (rows: any) => {
    console.log(rows)
    rows.forEach(function (r: any) {
      r.row.selected = true;
    });
    alert()
    this.forceUpdate();

  };

  onRowsDeselected = (rows: any) => {

    rows.forEach(function (r: any) {
      r.row.selected = false;
    });
    this.forceUpdate();
  };

  




//   getCellActions(column: any, row: any) {

//     if (column.key === "selected" && row.result_code === 10 && row.bk_no > 0) {
//       return [{
//         icon: <div className="float-right" style={{ textAlign: "center", paddingTop: "5px", paddingRight: "-5px", width: "100px", height: "100px", color: "green" }}>{row.selected === 1 ? <i className="fas fa-check" style={{ marginLeft: "20px" }}></i> : ""}</div>,
//         callback: () => {
//           // row.select = row.select === 1 ? 0 : 1;

//           let w = this.props.application_transfer_accounts.map((q: any) => {
//             if (q.id === row.id) return { ...q, selected: row.selected === 1 ? 0 : 1 };
//             return q;
//           })
//           this.props.change_application_transfer_accounts(w)
//         }
//       }]

//     } else if (column.key === "selected") {
//       return [{
//         icon: <div className="float-right" style={{ textAlign: "right", paddingRight: "2px", width: "100px", height: "40px", color: "#000000", background: "#CCC" }}> </div>,
//         callback: () => {

//           //   let estimateMonies2 = this.props.estimateMonies2

//           //   if(estimateMonies2.filter(a=>a.rentMAccountId===row.rentMAccountId)[0].taxAmount>0){
//           //     estimateMonies2.filter(a=>a.rentMAccountId===row.rentMAccountId)[0].taxAmount= 0
//           //     estimateMonies2.filter(a=>a.rentMAccountId===row.rentMAccountId)[0].tax= false
//           // }else{
//           //     estimateMonies2.filter(a=>a.rentMAccountId===row.rentMAccountId)[0].taxAmount=  Math.round(row.amount*0.1)
//           //     estimateMonies2.filter(a=>a.rentMAccountId===row.rentMAccountId)[0].tax= true
//           // }

//           //   this.props.change_estimateMonies2(estimateMonies2)
//           //   this.props.check_estimates()
//           //   this.setState({refresh:!this.state.refresh})
//         }
//       }]
//     } else if (column.key === "deleted") {



//       return [{
//         icon: <div className="float-right" style={{ textAlign: "center", paddingTop: "5px", paddingRight: "-5px", width: "100px", height: "100px", color: "#ff0000" }}>{row.deleted === 1 ? <i className="fas fa-check" style={{ marginLeft: "20px" }}></i> : ""}</div>,
//         callback: () => {
//           // row.deleted = row.deleted === 1 ? 0 : 1;
//           //         console.log(row.delete)
//           let w = this.props.application_transfer_accounts.map((q: any) => {
//             if (q.id === row.id) return { ...q, deleted: row.deleted === 1 ? 0 : 1 };
//             return q;
//           })
//           console.log(w)

//           this.props.change_application_transfer_accounts(w)
//           //         // this.setState({ refresh: !this.state.refresh })
//           //       }
//           //     }]
//           //   } else if (column.key === "search") {
//           //     if (!row.rent_contract_name1) {
//           //       return [{
//           //         icon: <Button
//           //           color="primary"
//           //           variant="contained"
//           //           size="small"
//           //           type="submit"

//           //           style={{ margin: 2, minWidth: 0, width: 50 }}
//           //         // onClick={()=>this.add(12)}
//           //         >検索
//           // </Button>,
//           //         callback: () => {
//           //           this.props.change_search_id(row.id)

//           //           this.props.change_search_detail(row)
//           //           // this.props.togglecontract()

//           //           this.props.change_search_modal(true)
//           //         }
//           //       }]
//           //     } else {
//           //       return [{
//           //         icon: <Button
//           //           color="primary"
//           //           variant="outlined"
//           //           size="small"
//           //           type="submit"

//           //           style={{ margin: 2, minWidth: 0, width: 50 }}
//           //         // onClick={()=>this.add(12)}
//           //         >編集
//           // </Button>,
//           //         callback: () => {
//           //           this.props.change_search_id(row.id)
//           //           this.props.change_search_detail(row)
//           //           this.props.change_search_modal(true)
//         }
//       }]
//     } else if (column.key === "rent_customer_name" && row.bk_no) {



//       return [{
//         icon: <PersonIcon />,
//         callback: () => {
//           // row.deleted = row.deleted === 1 ? 0 : 1;
//           //         console.log(row.delete)


//           // let w = this.props.application_transfer_accounts.map((q: any) => {
//           //   if (q.id === row.id) return { ...q, deleted: row.deleted === 1 ? 0 : 1 };
//           //   return q;
//           // })
//           // console.log(w)

//           // this.props.change_application_transfer_accounts(w)

//         }
//       }]
//     }else if (column.key === "contract_date" ) {



//       return [{
//         icon: <PersonIcon />,
//         callback: () => {
//           // row.deleted = row.deleted === 1 ? 0 : 1;
//           //         console.log(row.delete)
     
//           window.open(`https://crm.homestation.jp/contracts/` + row.rent_contract_id, '_blank', 'noopener')

//           // let w = this.props.application_transfer_accounts.map((q: any) => {
//           //   if (q.id === row.id) return { ...q, deleted: row.deleted === 1 ? 0 : 1 };
//           //   return q;
//           // })
//           // console.log(w)

//           // this.props.change_application_transfer_accounts(w)

//         }
//       }]
//     }else if (column.key === "section_name" ) {



//       return [{
//         icon: <PersonIcon />,
//         callback: () => {
//           // row.deleted = row.deleted === 1 ? 0 : 1;
//           //         console.log(row.delete)
     
//           window.open(`https://www.homestation.jp/manage/contract/detail/view?w_id=` + row.workflow_id, '_blank', 'noopener')

//           // let w = this.props.application_transfer_accounts.map((q: any) => {
//           //   if (q.id === row.id) return { ...q, deleted: row.deleted === 1 ? 0 : 1 };
//           //   return q;
//           // })
//           // console.log(w)

//           // this.props.change_application_transfer_accounts(w)

//         }
//       }]
//     }



//   }





  getRowCount() {
    let count = this.props.application_transfer_accounts.length;
    if (this.state.refresh && count > 0) {
      count--; // hack for update data-grid
      this.setState({
        refresh: false
      });
    }

    return count;
  }






  render() {

    return (
        <Modal isOpen={this.props.transfer_modal} toggle={()=>this.props.change_transfer_modal(false)} size="xl" fade={false}>

          <ModalHeader toggle={()=>this.props.change_transfer_modal(false)}>新規登録</ModalHeader>
          <ModalBody>
            <div><MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja}>
            <KeyboardDatePicker
            disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="申込完了日"
                    //   showTodayButton={true}
                    style={{ float: "left" }}
                    // defaultValue={}
                    // onChange={this.onChangeContractStartDate}
                    autoOk={true}
                    // error={true}
                    // helperText="契約日を選択してください"
                    //   errorMessages={['契約日を選択してください']}
                    name="start_date"
                    value={this.state.applicationDate}
                    onChange={(a:any)=>this.setState({applicationDate:moment(a).format('YYYY/MM/DD')})}
                    //    value={this.props.estimate_search.contractDateStart}
                    //    value={this.props.estimateData.contractDate}
                    //              onChange={this.handleContractionDateChange}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  //   minDateMessage="契約日を選択してください"
                  // minDate={new Date("2000-01-01")}
                  // invalidDateMessage={"日付の形式が違います"}
                  />
                  
            </MuiPickersUtilsProvider>
                  <div style={{margin:'28px 10px 0 10px',display:'inline-block'}}>～</div>
                  
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja}>
                  <KeyboardDatePicker
            disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="申込完了日"
                    //   showTodayButton={true}
                    // defaultValue={}
                    // onChange={this.onChangeContractStartDate}
                    autoOk={true}
                    // error={true}
                    // helperText="契約日を選択してください"
                    //   errorMessages={['契約日を選択してください']}
                    name="start_date"
                    value={this.state.applicationEndDate}
                    onChange={(a:any)=>this.setState({applicationEndDate:moment(a).format('YYYY/MM/DD')})}
                    //    value={this.props.estimate_search.contractDateStart}
                    //    value={this.props.estimateData.contractDate}
                    //              onChange={this.handleContractionDateChange}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  //   minDateMessage="契約日を選択してください"
                  // minDate={new Date("2000-01-01")}
                  // invalidDateMessage={"日付の形式が違います"}
                  />
                  <button
                          type="button"
                          style={{ margin: "20px 5px 5px 5px",float: "right" }}
                          className="btn btn-primary"
                          onClick={()=>this.props.new_rent_transfer_accounts({StartDate:this.state.applicationDate,EndDate:this.state.applicationEndDate})}
                        >検索</button>
                <ReactDataGrid
                    // ref={node => this.grid = node}
                    enableCellSelect={false}
                    enableRowSelect={false}
                    enableCellAutoFocus={false}
                    columns={this.state.columns}
                    rowGetter={(i: number) => this.props.application_transfer_accounts[i]}

                    // getCellActions={this.getCellActions}



                    rowsCount={this.getRowCount()}
                    headerRenderer={true}
                    dragable={true}

                    // onCellSelected={false}
                    // onColumnResize={(idx, width) =>
                    //     console.log(`Column ${idx} has been resized to ${width}`)
                    // }
                    // emptyRowsView={this.EmptyRowsView}
                    onRowClick={this.onRowClick}
                    // rowSelection={{
                    //   showCheckbox: true,
                    //   enableShiftSelect: true,
                    //   onRowsSelected: this.onRowsSelected,
                    //   onRowsDeselected: this.onRowsDeselected,
                    //   selectBy: {
                    //     isSelectedKey: 'selected'
                    //     // indexes: this.state.selectedIndexes
                    //   }
                    // }}
                    // onGridSort={(sortColumn: any, sortDirection: any) => { this.sortRows(this.props.application_transfer_accounts, sortColumn, sortDirection) }}
                    //onCellSelected={this.getSelectedCell}
                    minHeight={window.innerHeight - 260} 
                />
                </MuiPickersUtilsProvider>
            </div>
          </ModalBody>
          <ModalFooter>
          <button
                  type="button"
                  disabled={this.props.application_transfer_accounts.length > 0 ? false : true}
                  style={{ margin: "5px" }}
                  className="btn btn-primary float-left"
                  onClick={()=>this.props.registration_rent_transfer_accounts(this.props.application_transfer_accounts)}
                >取り込み</button>
          </ModalFooter>
        </Modal >
    );
  }


}



const mapStateToProps = (state: any) => {
  return {
    // rent_contracts_list: state.rentContractsReducer.rent_contracts_list,
    shops: state.masterReducer.shops,
    application_transfer_accounts: state.Transfer.application_transfer_accounts,
    transfer_modal: state.Transfer.transfer_modal
  }
}
function mapDispatchToProps(dispatch: any) {
  return {
    change_transfer_modal(state: any) {
      dispatch(Transfer.change_transfer_modal(state))
    },
    new_rent_transfer_accounts(state: any) {
        dispatch(Transfer.new_rent_transfer_accounts(state))
    },
    registration_rent_transfer_accounts(state: any) {
        dispatch(Transfer.registration_rent_transfer_accounts(state))
    },
    // change_search_id(state: any) {
    //   dispatch(Transfer.change_search_id(state))
    // },
    // change_search_modal(state: any) {
    //   dispatch(Transfer.change_search_modal(state))
    // },
    // change_grid_update(state: any) {
    //   dispatch(Transfer.change_grid_update(state))
    // },
    // change_search_detail(state: any) {
    //   dispatch(Transfer.change_search_detail(state))
    // },
    // change_kyousais(state: any) {
    //   dispatch(Transfer.change_kyousais(state))
    // },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountingGridComponent);